import { openAgentChat } from './openAgentChat'

export const openRefineInChat = (publicId: string, title?: string): void => {
  const prompt = `Refine my saved widget "${title || publicId}" (public_id: ${publicId}). I want to change: `
  openAgentChat(prompt, {
    mode: 'code',
    context: { aiWidgetPublicId: publicId, aiWidgetTitle: title }
  })
}
